import { Injectable } from '@angular/core';
import { RESTServiceBase } from '../../common/service.base';
import { WorkflowInstanceDescriptor } from './model/workflow.instance';
import { List } from '../../common/model/List_T';
import { AppConfig } from '../../configuration/app.config';
import { AuthService } from '../../services/auth.service';
import { View } from '../../common/model/view';

@Injectable()
export class WorkflowInstanceService extends RESTServiceBase {

  constructor(
    private authService: AuthService,
    private config: AppConfig
  ) {
    super(
      'v1',
      'WorkflowInstanceManagement',
      authService,
      config.WMSConfig
    );

  }

  public create(workflowInstance: WorkflowInstanceDescriptor): Promise<WorkflowInstanceDescriptor> {
    return super.post<WorkflowInstanceDescriptor>(
      new WorkflowInstanceDescriptor({
        id: undefined,
        href: undefined,

        workflowTemplateId: workflowInstance.workflowTemplateId,
        relatedObjectId: workflowInstance.relatedObjectId,
        relatedObjectType: workflowInstance.relatedObjectType,
        workflowInstanceState: workflowInstance.workflowInstanceState,
        currentStepId: workflowInstance.currentStepId,
        context: workflowInstance.context,
        reference: workflowInstance.reference,

        modified: workflowInstance.modified,
        deleted: workflowInstance.deleted
      }));
  }

  public getWorkflowInstances(view?: View): Promise<List<WorkflowInstanceDescriptor>> {
    return super.get<List<WorkflowInstanceDescriptor>>(undefined, view);
  }

  public delete(id: string): Promise<void> {
    return super.delete(id);
  }

  public update(id: string, workflowInstance: WorkflowInstanceDescriptor): Promise<WorkflowInstanceDescriptor> {
    return super.put<WorkflowInstanceDescriptor>(id, workflowInstance);
  }

  public getById(id: string): Promise<WorkflowInstanceDescriptor> {
    return super.get<WorkflowInstanceDescriptor>(id);
  }

  public async isServiceAvailable(): Promise<boolean> {
    return await super.isServiceAvailable();
  }
}




// WEBPACK FOOTER //
// ./src/app/modules/workflow.instance/workflow.instance.service.ts